import { Entity, Field } from "typegraph";
@Entity({ many: "messageCount" })
export default class MessageCount {
    @Field()
    public count: number;
}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/MessageCount.ts